module.exports = __webpack_public_path__ + "img/AWS.56765877.png";